// Cliente Supabase. Só a chave PÚBLICA (anon) — P-003 da constituição.
import { createClient, type SupabaseClient, type SupportedStorage } from '@supabase/supabase-js';

export interface SupabaseEnv {
  url: string;
  anonKey: string;
}

export function readSupabaseEnv(env: Record<string, string | undefined> = import.meta.env): SupabaseEnv | null {
  const url = env.VITE_SUPABASE_URL?.trim();
  const anonKey = env.VITE_SUPABASE_ANON_KEY?.trim();
  return url && anonKey ? { url, anonKey } : null;
}

/**
 * Fluxo PKCE (Segurança, item 7). No desktop a sessão vai para o cofre do sistema
 * (storage = secureStorage); na web fica no armazenamento padrão (ASM-041).
 */
export function createSupabase(env: SupabaseEnv, storage?: SupportedStorage): SupabaseClient {
  return createClient(env.url, env.anonKey, {
    auth: {
      flowType: 'pkce',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: !storage,
      storage,
    },
  });
}
